var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option-item"},[_c('div',{staticClass:"quantity"},[_c('h5',{staticClass:"text-size"},[_vm._v(_vm._s(_vm.item.quantity)+" x")])]),_vm._v(" "),_c('div',{staticClass:"name"},[_c('h5',{staticClass:"text-size"},[_vm._v(_vm._s(_vm.item.name)+" ("+_vm._s(_vm.item.price)+")")])]),_vm._v(" "),_c('div',{staticClass:"price"},[_c('h5',{staticClass:"text-size"},[_vm._v("$"+_vm._s(this.getPrice(_vm.item)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392132b6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/CheckoutOptionItem.vue
// module id = 437
// module chunks = 0